import React from "react";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";

import { Column } from "../table";

import { SERVER_URI } from "../../constants";

import ValueCell from "./value-cell";

interface Props {
  // nodes?: any[];
  // // panelId?: string;
  // panelName: String;
  // startDate: number; // Date;
  // endDate: number; // Date;
  // widgetStatic?: boolean;
  // widgetTitle?: string;
  metaData: any;
  style?: React.CSSProperties;
  leftColumns?: (string | symbol)[];
  rightColumns?: (string | symbol)[];
  tableColumnExtensions?: any /*Table.ColumnExtension*/[];
  trendDuration?: string | null;
  onTrendDurationChange?: (trendDuration?: string) => void;
}

const LiveDataTableCell = ({ value, column, row, ...restProps }: any) => (
  <TableCell
    align={column.align}
    style={{ width: column.width ? `${column.width}px` : undefined }}
    {...restProps}
  >
    {value.ajaxUrl ? (
      <ValueCell metaData={value} />
    ) : !!value.hasImage ? (
      <div>
        <img
          src={`${SERVER_URI}${value.image}`}
          title={value.title}
          alt={value.title}
        />{" "}
        &nbsp;
        {value.content}
      </div>
    ) : (
      <div>
        {column.format
          ? column.format({ value: value.content, row })
          : value.content}
      </div>
    )}
  </TableCell>
);

// TODO onClick
function LiveDataTableMui(props: Props) {
  const {
    // nodes,
    // // panelId,
    // panelName,
    // startDate,
    // endDate,
    // widgetStatic,
    // widgetTitle,
    metaData,
    style,
    // leftColumns,
    // rightColumns,
    tableColumnExtensions,
    trendDuration,
    onTrendDurationChange,
  } = props;
  // console.log("table meta", metaData);
  // const { panelCollectionName } = useParams<any>();
  // const history = useHistory();

  const columns: Column[] = metaData.columns.map(
    (column: any, columnIndex: number) => ({
      id: column.headerData.content || `index_${columnIndex}`,
      label: column.headerData.headerTitle || column.headerData.content || " ",
      trendDuration: new URLSearchParams(column.headerData.link).get(
        "trendduration"
      ),
    })
  );
  if (tableColumnExtensions) {
    // console.log("tableColumnExtensions", tableColumnExtensions);
    tableColumnExtensions.forEach((columnExtension: any) => {
      const { columnName, align, width } = columnExtension;
      const column = columns.find((c) => c.id === columnName);
      // console.log("found column ", column, columnExtension);
      if (column) {
        column.align = align;
        column.width = width;
      }
    });
  }
  // const rows = metaData.rowData.map((row: any, rowIndex: number) =>
  //   row.reduce((accumulator: any, currentValue: any, columnIndex: any) => {
  //     return {
  //       ...accumulator,
  //       [metaData.columns[columnIndex].headerData.content ||
  //       `index_${columnIndex}`]: currentValue,
  //     };
  //   }, {})
  // );
  // console.log("columns", columns);
  // console.log("rows", rows);
  // const [tableColumnExtensions] = useState([
  //   { columnName: 'amount', align: 'right', width: 140 },
  // ]);
  // const [leftColumns] = useState([/*'region', 'channel'*/]);
  // const [rightColumns] = useState([/*'amount'*/]);
  return (
    <TableContainer style={style}>
      <Table
        // className={classes.table}
        // aria-labelledby="tableTitle"
        // size={dense ? 'small' : 'medium'}
        size={"small"}
        // aria-label="enhanced table"
      >
        <TableHead>
          <TableRow>
            {/* <TableCell
        // padding="checkbox"
        >
        </TableCell> */}
            {columns.map((column: any) => {
              // const searchParams = new URLSearchParams(column.link);
              // const trendDurationParam = searchParams.get("trendduration");
              // console.log("trenddd", column);
              return (
                <TableCell
                  key={column.id}
                  // align={headCell.numeric ? 'right' : 'left'}
                  // padding={headCell.disablePadding ? 'none' : 'default'}
                  // sortDirection={orderBy === headCell.id ? order : false}
                  align="center"
                  style={{
                    minWidth: column.width ? `${column.width}px` : undefined,
                  }}
                >
                  <TableSortLabel
                    active={
                      trendDuration
                        ? trendDuration === column.trendDuration
                        : false
                    }
                    // direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={(event: any) => {
                      event.preventDefault();
                      if (column.trendDuration && onTrendDurationChange) {
                        onTrendDurationChange(column.trendDuration);
                      }
                    }}
                  >
                    {column.label}
                    {/* {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null} */}
                  </TableSortLabel>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {metaData.rowData.map((row: any, rowIndex: number) => {
            // const isItemSelected = isSelected(row.name);
            // const labelId = `enhanced-table-checkbox-${index}`;

            return (
              <TableRow
                hover
                // onClick={(event) => handleClick(event, row.name)}
                // role="checkbox"
                // aria-checked={isItemSelected}
                // tabIndex={-1}
                // key={row.name}
                // selected={isItemSelected}
                key={rowIndex}
              >
                {row.map((cell: any, cellIndex: number) => (
                  <LiveDataTableCell
                    key={cellIndex}
                    value={cell}
                    column={columns[cellIndex]}
                    row={row}
                  />
                ))}
                {/* <TableCell padding="checkbox">
                  <Checkbox
                    checked={isItemSelected}
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </TableCell>
                <TableCell component="th" id={labelId} scope="row" padding="none">
                  {row.name}
                </TableCell>
                <TableCell align="right">{row.calories}</TableCell>
                <TableCell align="right">{row.fat}</TableCell>
                <TableCell align="right">{row.carbs}</TableCell>
                <TableCell align="right">{row.protein}</TableCell> */}
              </TableRow>
            );
          })}
          {/* {emptyRows > 0 && (
          <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
            <TableCell colSpan={6} />
          </TableRow>
        )} */}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default LiveDataTableMui;
